import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";

export default function NotFound() {
  const location = useLocation();
  const [state, setState] = useState("checking"); // "checking" | "404" | "redirecting"

  useEffect(() => {
    let cancelled = false;
    const path = location.pathname + (location.search || "");
    api
      .get("/redirects/lookup", { params: { path } })
      .then((r) => {
        if (cancelled) return;
        const target = r.data?.to_path;
        if (!target) {
          setState("404");
          return;
        }
        setState("redirecting");
        // For internal paths we use SPA navigation so React Router takes over.
        if (target.startsWith("/")) {
          window.location.replace(target);
        } else {
          window.location.href = target;
        }
      })
      .catch(() => {
        if (!cancelled) setState("404");
      });
    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search]);

  if (state === "checking" || state === "redirecting") {
    return (
      <div
        className="max-w-3xl mx-auto px-4 md:px-8 py-20 md:py-32 text-center"
        data-testid="not-found-checking"
      >
        <Seo title="Loading..." path="" noindex />
        <div className="font-mono uppercase text-[11px] tracking-widest opacity-60">
          {state === "redirecting" ? "Redirecting..." : "Checking..."}
        </div>
      </div>
    );
  }

  return (
    <div
      className="max-w-3xl mx-auto px-4 md:px-8 py-20 md:py-32 text-center"
      data-testid="not-found"
    >
      <Seo title="Page not found" path="" noindex />
      <div className="font-mono uppercase text-[11px] tracking-widest pcs-text-pink mb-3">
        Trick, no treat
      </div>
      <h1 className="font-display text-7xl md:text-9xl tracking-tighter leading-none">404</h1>
      <p className="mt-4 text-lg text-gray-800">That page is in another costume.</p>
      <Link
        to="/"
        className="mt-8 inline-block brut pcs-bg-pink text-white px-6 py-3 font-bold uppercase tracking-wide brut-press"
      >
        Back home
      </Link>
    </div>
  );
}
